export default __webpack_public_path__ + "static/media/parent.89e9069c.svg";